var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2027_10091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1703 3H19.5351L27.4712 11.2717V27.359C27.4712 29.3646 25.8358 31 23.8302 31H10.1703C8.15612 31 6.5293 29.3646 6.5293 27.359V6.64095C6.5293 4.62682 8.15612 3 10.1703 3Z",
    fill: "#FFB11F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5254 3V11.2029H27.47L19.5254 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6641 22.9999V18.6362H21.5476C21.8714 18.6362 22.1548 18.6952 22.3977 18.8131C22.6406 18.931 22.8295 19.1007 22.9645 19.3223C23.0994 19.5439 23.1669 19.8095 23.1669 20.1192C23.1669 20.4317 23.0973 20.6952 22.9581 20.9097C22.8203 21.1242 22.6264 21.2861 22.3764 21.3955C22.1278 21.5048 21.8374 21.5595 21.505 21.5595H20.38V20.6391H21.2663C21.4055 20.6391 21.5241 20.622 21.6222 20.5879C21.7216 20.5524 21.7976 20.4963 21.8501 20.4196C21.9041 20.3429 21.9311 20.2428 21.9311 20.1192C21.9311 19.9942 21.9041 19.8926 21.8501 19.8145C21.7976 19.735 21.7216 19.6767 21.6222 19.6398C21.5241 19.6014 21.4055 19.5823 21.2663 19.5823H20.8487V22.9999H19.6641ZM22.2209 20.997L23.3118 22.9999H22.0249L20.9595 20.997H22.2209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0226 22.9999H14.7441L16.1845 18.6362H17.8038L19.2441 22.9999H17.9657L17.0112 19.8379H16.9771L16.0226 22.9999ZM15.7839 21.2783H18.1873V22.1646H15.7839V21.2783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8809 22.9999V18.6362H12.7644C13.0882 18.6362 13.3716 18.6952 13.6145 18.8131C13.8574 18.931 14.0463 19.1007 14.1813 19.3223C14.3162 19.5439 14.3837 19.8095 14.3837 20.1192C14.3837 20.4317 14.3141 20.6952 14.1749 20.9097C14.0371 21.1242 13.8432 21.2861 13.5932 21.3955C13.3446 21.5048 13.0542 21.5595 12.7218 21.5595H11.5968V20.6391H12.4831C12.6223 20.6391 12.7409 20.622 12.839 20.5879C12.9384 20.5524 13.0144 20.4963 13.0669 20.4196C13.1209 20.3429 13.1479 20.2428 13.1479 20.1192C13.1479 19.9942 13.1209 19.8926 13.0669 19.8145C13.0144 19.735 12.9384 19.6767 12.839 19.6398C12.7409 19.6014 12.6223 19.5823 12.4831 19.5823H12.0655V22.9999H10.8809ZM13.4377 20.997L14.5286 22.9999H13.2417L12.1763 20.997H13.4377Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2027_10091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon1);
export default __webpack_public_path__ + "static/media/file_icon1.8f4a8158ac4d3bb526ac564e78535d9b.svg";
export { ForwardRef as ReactComponent };